var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_2455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 16C4.2998 17.5759 4.61019 19.1363 5.21325 20.5922C5.81631 22.0481 6.70022 23.371 7.81452 24.4853C8.92883 25.5996 10.2517 26.4835 11.7076 27.0866C13.1635 27.6896 14.7239 28 16.2998 28C17.8757 28 19.4361 27.6896 20.892 27.0866C22.3479 26.4835 23.6708 25.5996 24.7851 24.4853C25.8994 23.371 26.7833 22.0481 27.3864 20.5922C27.9894 19.1363 28.2998 17.5759 28.2998 16C28.2998 14.4241 27.9894 12.8637 27.3864 11.4078C26.7833 9.95189 25.8994 8.62902 24.7851 7.51472C23.6708 6.40042 22.3479 5.5165 20.892 4.91345C19.4361 4.31039 17.8757 4 16.2998 4C14.7239 4 13.1635 4.31039 11.7076 4.91345C10.2517 5.5165 8.92883 6.40042 7.81452 7.51472C6.70022 8.62902 5.81631 9.95189 5.21325 11.4078C4.61019 12.8637 4.2998 14.4241 4.2998 16Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2998 13.333C12.2998 14.3939 12.7212 15.4113 13.4714 16.1614C14.2215 16.9116 15.2389 17.333 16.2998 17.333C17.3607 17.333 18.3781 16.9116 19.1282 16.1614C19.8784 15.4113 20.2998 14.3939 20.2998 13.333C20.2998 12.2721 19.8784 11.2547 19.1282 10.5046C18.3781 9.75444 17.3607 9.33301 16.2998 9.33301C15.2389 9.33301 14.2215 9.75444 13.4714 10.5046C12.7212 11.2547 12.2998 12.2721 12.2998 13.333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52344 25.1317C8.85345 24.0333 9.52873 23.0706 10.4491 22.3863C11.3695 21.702 12.4859 21.3327 13.6328 21.333H18.9661C20.1144 21.3326 21.2323 21.7029 22.1533 22.3887C23.0743 23.0746 23.7494 24.0394 24.0781 25.1397",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_2455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.299805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/userProfile-icon.faa1925e45b4036c1df5f087113a5dde.svg";
export { ForwardRef as ReactComponent };